import { FormattedMessage } from 'react-intl';
import Button from '../../../../../components_new/Button';
import { CtaWrapper } from '../../styles';
import { LoadingSpinner } from '../../../../../components/loading-spinner/loading-spinner.component';

const CtaButton = (props) => {
  const { textKey, disabled = false, isLoading = false, ...restProps } = props;

  return (
    <CtaWrapper>
      <Button color="blue" disabled={disabled || isLoading} {...restProps}>
        <FormattedMessage id={textKey} />
      </Button>
      {isLoading && <LoadingSpinner small />}
    </CtaWrapper>
  );
};

export default CtaButton;
